module.exports = {
  name: 'ooba',
  isSimplyBased: true,
  logo: 'ooba.png',
  logo_text: 'Brought to you by',
  logo_link: 'https://www.ooba.co.za',
  logo_fineprint: '',
  //'Ooba is a registered FSP (46293)',
  google_font: 'Montserrat:wght@400;500;600;700;800',
  font_headings: 'Montserrat',
  margintop: '80px',
  font_body: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  colours: {
    primary: {
      darkest: '#69BE28',
      darker: '#69BE28',
      dark: '#69BE28',
      base: '#69BE28',
      light: '#69BE28',
      lighter: '#69BE28',
      lightest: '#fff',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, #69BE28 0%, #69BE28 100%);',
      gradient_hover: 'linear-gradient(45deg, #69BE28 0%, #69BE28 100%);'
    },
    secondary: {
      darkest: '#000038',
      darker: '#00529C',
      dark: '#007DBE',
      base: '#00AEEF',
      light: '#00BFDF',
      lighter: '#74CEE1',
      lightest: '#96D5D2',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, #00AEEF 0%, #00AEEF 100%);',
      gradient_hover: 'linear-gradient(45deg, #00AEEF 0%, #00AEEF 100%);'
    },
    tertiary: {
      darkest: '#560835',
      darker: '#7A054A',
      dark: '#A01D29',
      base: '#CB0044',
      light: '#EF4123',
      lighter: '#F15B4E',
      lightest: '#F48473',
      light_text: '#fff',
      dark_text: '#CB0044',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, #CB0044 0%, #CB0044 100%);',
      gradient_hover: 'linear-gradient(45deg, #CB0044 0%, #CB0044 100%);'
    },
    ghost: {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#69BE28',
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-secondary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#00AEEF',
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-tertiary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#CB0044',
      gradient: 'none',
      gradient_hover: 'none'
    },
    filled: {
      darkest: '#fff',
      darker: '#fff',
      dark: '#fff',
      base: '#fff',
      light: '#fff',
      lighter: '#fff',
      lightest: '#fff',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#69BE28',
      gradient: 'none',
      gradient_hover: 'none'
    },
    neutral: {
      darkest: '#121B21',
      darker: '#3C5D5D',
      dark: '#636466',
      base: '#d1d6da',
      light: '#BACAD3',
      lighter: '#BACAD3',
      lightest: '#E6E7E8',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'none',
      gradient_hover: 'none'
    },
    danger: {
      darkest: '#662222',
      darker: '#D94949',
      dark: '#D94949',
      base: '#FF5656',
      light: '#FF6F6F',
      lighter: '#FF9999',
      lightest: '#FFBBBB',
      light_text: '#fff',
      dark_text: '#662222',
      border_colour: 'transparent',
      gradient: 'none',
      gradient_hover: 'none'
    }
  }
};